import { setCurrentClientIdForHeader } from '@/configs/axios'
import type { UserClientDto } from '@/models/client'
import * as userClientService from '@/services/userClientService'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useClientStore = defineStore('client', () => {
  const currentClientId = ref<string | null>(null)
  const clients = ref<UserClientDto[]>([])
  const clientChangeKey = ref(0)
  const clientsLoading = ref(false)

  function setCurrentClient(id: string | null, bumpKey = true) {
    currentClientId.value = id
    setCurrentClientIdForHeader(id)
    if (bumpKey) clientChangeKey.value += 1
  }

  function resetState() {
    clientsLoading.value = false
    clients.value = []
    currentClientId.value = null
    setCurrentClientIdForHeader(null)
  }

  async function loadClientsFromApi() {
    if (clientsLoading.value) return
    clientsLoading.value = true
    try {
      const [clientsRes, currentRes] = await Promise.all([
        userClientService.getMyClients(),
        userClientService.getCurrentClient(),
      ])
      clients.value = clientsRes.data
      const newId = currentRes.data?.id ?? clientsRes.data[0]?.id ?? null
      const changed = newId !== currentClientId.value
      currentClientId.value = newId
      setCurrentClientIdForHeader(newId)
      if (changed) clientChangeKey.value += 1
    } catch {
      clients.value = []
      currentClientId.value = null
      setCurrentClientIdForHeader(null)
    } finally {
      clientsLoading.value = false
    }
  }

  return {
    currentClientId,
    clients,
    clientChangeKey,
    clientsLoading,
    setCurrentClient,
    resetState,
    loadClientsFromApi,
  }
})
